"use client";
import React, { StyleHTMLAttributes } from "react";

import clsx from "clsx";
import { transparentize } from "polished";
import styled, { DefaultTheme, css, useTheme } from "styled-components";

export const Spinner = ({
  skin = "primary",
  width = 16,
  strokeWidth = 2,
  className,
  hasContainer = false,
  hasContainerOpacity = 0.1,
  counter,
  fixed = false,
  style,
  fullWidth = false,
  ...props
}) => {
  const { menuOpen } = useTheme() ?? {};
  const styles = fullWidth ? {
      maxWidth: "100%",
        left: "0",
        zIndex: 3,
        transition: "0.5s ease all",
  } : !menuOpen
    ? {
        maxWidth: "calc(100% - 65px)",
        left: "65px",
        zIndex: 3,
        transition: "0.5s ease all",
      }
    : {
        maxWidth: "calc(100% - 252px)",
        left: "252px",
        zIndex: 3,
        transition: "0.5s ease all",
      };
  return (
    <StyledLoaderContainer
      hasContainer={hasContainer}
      hasContainerOpacity={hasContainerOpacity}
      fixed={fixed}
      style={fixed ? styles : style}
      className="spinner"
    >
      <IconSpinner
        skin={skin}
        className={clsx("spinner", skin, className)}
        {...props}
      >
        <svg
          width={width}
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx={50} cy={50} r="40" strokeWidth={strokeWidth} />
          {counter !== "" ? (
            <text x="50" y="56" textAnchor="middle">
              {counter}
            </text>
          ) : null}
        </svg>
      </IconSpinner>
    </StyledLoaderContainer>
  );
};

const spinnerStyle = (theme, skin) => {
  return css`
    svg {
      stroke: ${theme?.colors.primary};

      .text {
        font-size: 20px;
        color: ${theme?.colors.primary};
      }
    }
  `;
};

const IconSpinner = styled.div`
  ${({ theme, skin }) => css`
    &.spinner {
      ${spinnerStyle(theme, skin ? skin : "primary")}

      &.centerAlign {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      svg {
        /* animation: rotate 3.6s linear infinite; */

        circle {
          fill: none;
          stroke-dasharray: 300;
          animation: outline 2s cubic-bezier(0.77, 0, 0.18, 1) infinite;
        }
      }

      @keyframes outline {
        0% {
          stroke-dashoffset: 0;
        }
        50% {
          stroke-dashoffset: 300;
        }
        100% {
          stroke-dashoffset: 600;
        }
      }

      @keyframes rotate {
        from {
          transform: rotate(0turn);
        }
        to {
          transform: rotate(-1turn);
        }
      }
    }
  `}
`;

const StyledLoaderContainer = styled.div`
  ${({ theme, hasContainer, hasContainerOpacity, fixed }) => css`
    ${hasContainer &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${transparentize(
        hasContainerOpacity,
        theme?.colors?.white || "#ffffff"
      )};
      z-index: 99;
    `}

    ${fixed &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      display: flex;
      height: 100%;
      width: 100%;
      z-index: 1;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      background-color: ${transparentize(
        hasContainerOpacity,
        theme?.colors?.black || "#ffffff"
      )};
    `}
  `}
`;
